import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken  } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import PropTypes from 'prop-types';
import AddContractPo from '../contracts/AddContractPo';
import EditContractOrder from '../contracts/EditContractOrder';
import Swal from 'sweetalert2';
import $ from "jquery";

import {
  MenuItem,
} from '@mui/material';
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
const Viewcontract = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});
  const [showmodel, setshowmodel] = useState(false);
  const [contractid, setContractid] = useState(null);
    const [data, setData] = useState([]);
    const [dataConfirmed, setDataConfirmed] = useState([]);
    const [dataFinished, setDataFinished] = useState([]);
    const [dataInproduction, setDataInproduction] = useState([]);
    const [dataCancelled, setDataCancelled] = useState([]);
    const [dataDraft, setDataDraft] = useState([]);
    const [dataShipped, setDataShipped] = useState([]);
    const [dataDelivered, setDataDelivered] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);
    const [loading, setLoading] = useState(true);

  // Alternative approach - single state object for edit modal
  const [editModal, setEditModal] = useState({
    show: false,
    itemData: null
  });

  useEffect(() => {
    setPermission(FindModuleById(452)); 
    console.log(permission);

    axios.get(`/contracts/view/${id}`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }).then((response) => {
      if(response.data.code === 200) {
        setValue(response.data.data.contract);
        const order_id = response.data.data.contract.id;
          setLoading(false);

    if(order_id !=""){
      axios
      .get(`/orders-by-contract/${order_id}`,  {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
           
          let all_orders  =response.data.data.orders;
          let order_Confirmed = [];
          let order_Finished = [];
          let order_InProcess = [];
          let order_Draft = [];
          let order_Cancelled = [];
          let order_Shipped = [];
          let order_Delivered = [];
        all_orders.forEach((order) => {
            switch (order.order_status) {
              case 1:
                order_Confirmed.push(order);
              break;
              case 2:
                order_Finished.push(order);
              break;
              case 3:
                order_InProcess.push(order);
              break;
              case 4:
                order_Draft.push(order);
              break;
              case 5:
                order_Cancelled.push(order);
              break;
              case 6:
                order_Shipped.push(order);
              break;
              case 7:
                order_Delivered.push(order);
              break;
            
              default:
                break;
            }
          });
          setData(all_orders);
          setDataConfirmed(order_Confirmed);
          setDataFinished(order_Finished);
          setDataInproduction(order_InProcess);
          setDataDraft(order_Draft);
          setDataCancelled(order_Cancelled);
          setDataShipped(order_Shipped);
          setDataDelivered(order_Delivered);

        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }
      }
    })
    .catch((error) => {
      console.log(error);
    });



     axios
          .get("/helpers/orders-status", {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          })
          .then((response) => {
            if (response.data.code === 200) {
              let orders_status = response.data.data.orders_status;
              setStatusOptions(orders_status);
            } else {
              console.log("API response is not an array");
            }
          })
          .catch((error) => {
            console.log(error);
          });
       
  }, [id]);

  // Debug useEffect to monitor edit modal state changes
  useEffect(() => {
   
  }, [editModal]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const addForm = (contract) => {
    console.log('add');
    console.log(contract);
    setContractid(contract);
    setshowmodel(true);
    
    console.log(contractid);
  };

  const handleClose = () => {
    setshowmodel(false);
    setEditModal({
      show: false,
      itemData: null
    });
  };

 const changeOrderStatus = (user_id, status,type) =>{

    Swal.fire({
      title: 'Do you want Change Status?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'green',
      cancelButtonColor: '#d33',
      confirmButtonText: 'CONFIRM',
      customClass: "swal-orders"
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/orders/change-status/${user_id}/${status}`, {headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
            .then((response) => {
              console.log(response.data.data.order_status);
              if (response.data.code === 200) {
                $("#status-"+type+"-"+user_id).text(response.data.data.order_status.title);
                $("#status-"+type+"-"+user_id).css('background-color',response.data.data.order_status.bg_color);
                $("#status-"+type+"-"+user_id).css('color',response.data.data.order_status.color);
                        const order_id = id;
                            if(order_id !=""){
                              axios
                              .get(`/orders-by-contract/${order_id}`,  {
                                headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
                              })
                              .then((response) => {
                                if (response.data.code === 200) {
                                  
                                  let all_orders  =response.data.data.orders;
                                  let order_Confirmed = [];
                                  let order_Finished = [];
                                  let order_InProcess = [];
                                  let order_Draft = [];
                                  let order_Cancelled = [];
                                  let order_Shipped = [];
                                  let order_Delivered = [];
                                all_orders.forEach((order) => {
                                    switch (order.order_status) {
                                      case 1:
                                        order_Confirmed.push(order);
                                      break;
                                      case 2:
                                        order_Finished.push(order);
                                      break;
                                      case 3:
                                        order_InProcess.push(order);
                                      break;
                                      case 4:
                                        order_Draft.push(order);
                                      break;
                                      case 5:
                                        order_Cancelled.push(order);
                                      break;
                                      case 6:
                                        order_Shipped.push(order);
                                      break;
                                      case 7:
                                        order_Delivered.push(order);
                                      break;
                                    
                                      default:
                                        break;
                                    }
                                  });
                                  setData(all_orders);
                                  setDataConfirmed(order_Confirmed);
                                  setDataFinished(order_Finished);
                                  setDataInproduction(order_InProcess);
                                  setDataDraft(order_Draft);
                                  setDataCancelled(order_Cancelled);
                                  setDataShipped(order_Shipped);
                                  setDataDelivered(order_Delivered);

                                } else {
                                  console.log("API response is not an array");
                                }
                              })
                              .catch((error) => {
                                console.log(error);
                              });
                            }
                
            
                Swal.fire(
                  'Changed!',
                  'Order Status has been changed Successfully.',
                  'success'
                );
                // setTimeout(() => {
                //  // window.location.href = "/orders";
                // }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            }); 
           }
    });


   
  
  }


  const OrderStatusCell = ({ row, statusOptions, changeOrderStatus}) => {
    return (
      <div className="btn-group custom-table-btn-group">
        <button
          type="button"
          className="btn btn-block dropdown-toggle me-1"
          id={`status-all-${row.original.id}`}
          style={{
            backgroundColor: row.original.status.bg_color,
            color: row.original.status.color,
          }}
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {row.original.status ? row.original.status.title : ''}
        </button>
        <div className="dropdown-menu">
          {statusOptions &&
            statusOptions.map((shipp) => (
              <button
                key={shipp.id}
                className="dropdown-item btn btn-block"
                style={{ backgroundColor: shipp.bg_color, color: shipp.color }}
                onClick={() => changeOrderStatus(row.original.id, shipp.id, 'all')}
              >
                {shipp.title}
              </button>
            ))}
        </div>
      </div>
    );
  };
  
  // ✅ Define PropTypes
  OrderStatusCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        status: PropTypes.shape({
          title: PropTypes.string,
          bg_color: PropTypes.string,
          color: PropTypes.string,
        }),
      }).isRequired,
    }).isRequired,
    statusOptions: PropTypes.array.isRequired,
    changeOrderStatus: PropTypes.func.isRequired,
  };
  const columns = [
    {
      header: 'PO Number',
      accessorFn: (row) => `${row.po_number}`,
     },
    {
      header: 'Customer',
      accessorFn: (row) => `${row.customer_detail ? row.customer_detail.company_name : ''}`,
    },
    {
      header: 'Contract',
      accessorFn: (row) => `${row.contract_detail ? row.contract_detail.contract_number : ''}`,
    },
    
    {
      accessorKey: 'quantity', //normal accessorKey
      header: 'Quantity',
    },
    {
      accessorKey: 'price', //normal accessorKey
      header: 'Price',
    },
    {
      accessorKey: 'lot_number', //normal accessorKey
      header: 'Lot Number',
    },
    {
      header: 'Processing Line',
      accessorFn: (row) => `${(row.order_location)?row.order_location.title:""} `,
    },
    {
      header: 'Order Status',
      accessorFn: (row) => `${row.status ? row.status.title : ''}`,
      Cell: (props) => <OrderStatusCell {...props} statusOptions={statusOptions} changeOrderStatus={changeOrderStatus}  />,
    },
    {
      header: 'Shipping Address',
      accessorFn: (row) => `${row.ship_address2 ? row.ship_address2.name : ''}`,
    },
   
    {
      header: 'Shipping method',
      accessorFn: (row) => `${row.shipping_method ? row.shipping_method : ''}`,
    },
    {
      header: 'Loading Type',
      accessorFn: (row) => `${row?.loading_type === 2 ? 'Pallets Loaded' : 'Floor Loaded'}`,
    },

    {
      header: 'Created By',
      accessorFn: (row) =>
        `${row.createdby ? row.createdby.first_name + ' ' + row.createdby.last_name : ''}`,
    },
    {
      header: 'Updated By',
      accessorFn: (row) =>
        `${row.updatedby ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ''}`,
    },
    {
      header: 'Updated At',
      accessorFn: (row) => `${formatDateTime(row.updated_at)}`,
    },
  ];
  
          const formatDateTime = (isoString) => {
            const date = new Date(isoString);
          
            // Get the components
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            let hours = date.getHours();
            const minutes = String(date.getMinutes()).padStart(2, '0');
          
            // Determine AM/PM
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert to 12-hour format
          
            return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
          };
  
  const editItem = (order_detail) => {
 
    
    setEditModal({
      show: true,
      itemData: order_detail
    });
    
    console.log('Set editModal to show with itemData');
  };
  
  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/contracts/orders/delete/${item}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          console.log(response);
          if (response.data.code === 200) {
            Swal.fire(
              'Deleted!',
              'Your Record has been deleted.',
              'success'
            );
            setTimeout(() => {
              window.location.href = "/contracts-view/" + id;
            }, 500);
          }
        })
        .catch((error) => {
          console.log(error);
        });
      }
    });
  };

 
  
    let raw_data_invoice ='';
     if(value.file){
       AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
       AWS.config.update({
       accessKeyId: AWS_ACCESS_KEY_ID,
       secretAccessKey: AWS_SECRET_ACCESS_KEY,
       region: AWS_DEFAULT_REGION,
       signatureVersion: 'v4',
       });
       const s3 = new AWS.S3();
       var params = {Bucket: AWS_BUCKET, Key: value.file};
       raw_data_invoice = s3.getSignedUrl('getObject', params);
     
     }




  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Contract</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/contracts">Contracts</Link>
                    </li>
                    <li className="breadcrumb-item active">View Contract</li>
                  </ul>
                </div>
              </div>
            </div>
            <div>
                 {loading ? (
            <div className="text-center p-5">Loading...</div>
          ) : permission && permission.list === 1 && (
           <div className="row">
              <div className="col-md-12">
              
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">View Contract Info</h4>
                      <div style={{float:"right"}}>
                        <button onClick={() => addForm(id)} className="btn btn-primary">
                          <i className="fas fa-plus"></i>
                        </button>
                      </div>
                      
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <th className="p-3">Contract Number</th>
                            <td className="p-3">{value.contract_number}</td>
                          </tr>
                          <tr>
                            <th className="p-3">Customer</th>
                            <td className="p-3">
                              {value.customer_detail ? value.customer_detail.company_name : ""}
                            </td>
                          </tr>
                          <tr>
                            <th className="p-3">Product</th>
                            <td className="p-3">
                              {value.producttype ? value.producttype.title : ""}
                            </td>
                          </tr>
                          <tr>
                            <th className="p-3">Price</th>
                            <td className="p-3">{value.price}</td>
                          </tr>
                          <tr>
                            <th className="p-3">Quantity</th>
                            <td className="p-3">{value.quantity}</td>
                          </tr>
                          <tr>
                            <th className="p-3">Status</th>
                            <td className="p-3">
                              {value.contractstatus ? value.contractstatus.title : ""}
                            </td>
                          </tr>
                            <tr>
                          <th className="p-3">File</th>
                          <td className="p-3">
                           {raw_data_invoice != '' && (
                             
                                <a
                                  className="btn btn-primary invoicebtn"
                                  href={raw_data_invoice}
                                  target="_blank"
                                   rel="noopener noreferrer"
                                  download
                                >
                                  Download
                                </a>
                             
                          )}
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      

                      {/* Add Contract PO Modal */}
                      <AddContractPo  
                        contract={contractid} 
                        show={showmodel}  
                        handleClose={handleClose} 
                      />
                      
                      {/* Edit Contract Order Modal */}
                      <EditContractOrder  
                        itemId={editModal.itemData} 
                        show={editModal.show} 
                        handleClose={handleClose} 
                      />
                    </div>
                  </div>
                
              </div>

              <div className="col-sm-12">
          
            <section className="comp-section order-listing-page">
                <div className="row">
                <div className="col-md-12">
                    <div className="card bg-white">
                    
                    <div className="card-body">
                        <ul className="nav nav-tabs nav-tabs-bottom">
                         
                         <li className="nav-item">
                            <a className="nav-link active" href="#all-orders" data-bs-toggle="tab">All Orders ({data.length})</a>                                  
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataConfirmed" data-bs-toggle="tab"> Confirmed Orders ({dataConfirmed.length})</a>                                   
                        </li>                    
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataFinished" data-bs-toggle="tab"> Fnished Orders ({dataFinished.length})</a>                                   
                        </li>                   
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataInproduction" data-bs-toggle="tab"> In Process Orders ({dataInproduction.length})</a>                                   
                        </li>                    
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataDraft" data-bs-toggle="tab"> Draft Orders ({dataDraft.length})</a>                                   
                        </li>                   
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataCancelled" data-bs-toggle="tab"> Cancelled Orders ({dataCancelled.length})</a>                                   
                        </li>                 
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataShipped" data-bs-toggle="tab"> Shipped Orders ({dataShipped.length})</a>                                   
                        </li>                 
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataDelivered" data-bs-toggle="tab"> Delivered Orders ({dataDelivered.length})</a>                                   
                        </li>                    
                                    
                                         
                        </ul>
                        <div className="tab-content">
                     
                        <div className="tab-pane show active" id="all-orders">
                            <div className="row"  id="listing-followup-groupby" >
                              <div className="col-sm-12" >
                              <div className="card card-table">
                                <div className="card-body">
                                  <div className="table-responsive">
                                  <MaterialReactTable columns={columns} data={data} 
                                        enableColumnOrdering
                                        enablePinning
                                        enableRowActions
                                        enableSorting={true} // Enable sorting
                                        initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                        renderRowActionMenuItems={({ row }) => [
                                          permission?.update === 1 && (
                                            <MenuItem key="edit" onClick={() => editItem(row.original)}>
                                              Edit
                                            </MenuItem>
                                          ),
                                          permission?.delete === 1 && (
                                            <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                              Delete
                                            </MenuItem>
                                          ),
                                        ]}
                                      
                                      />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane " id="list-dataConfirmed">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataConfirmed} 
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                          initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                          renderRowActionMenuItems={({ row }) => [
                                          permission?.update === 1 && (
                                            <MenuItem key="edit" onClick={() => editItem(row.original)}>
                                              Edit
                                            </MenuItem>
                                          ),
                                          permission?.delete === 1 && (
                                            <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                              Delete
                                            </MenuItem>
                                          ),
                                        ]}
                                      
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                
                        
                        <div className="tab-pane " id="list-dataFinished">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataFinished} 
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                          initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                          renderRowActionMenuItems={({ row }) => [
                                          permission?.update === 1 && (
                                            <MenuItem key="edit" onClick={() => editItem(row.original)}>
                                              Edit
                                            </MenuItem>
                                          ),
                                          permission?.delete === 1 && (
                                            <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                              Delete
                                            </MenuItem>
                                          ),
                                        ]}
                                      
                                        
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                
                        
                        <div className="tab-pane " id="list-dataInproduction">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataInproduction} 
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                          initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                        renderRowActionMenuItems={({ row }) => [
                                          permission?.update === 1 && (
                                            <MenuItem key="edit" onClick={() => editItem(row.original)}>
                                              Edit
                                            </MenuItem>
                                          ),
                                          permission?.delete === 1 && (
                                            <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                              Delete
                                            </MenuItem>
                                          ),
                                        ]}
                                       
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                

                        <div className="tab-pane " id="list-dataDraft">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataDraft} 
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                          initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                        renderRowActionMenuItems={({ row }) => [
                                          permission?.update === 1 && (
                                            <MenuItem key="edit" onClick={() => editItem(row.original)}>
                                              Edit
                                            </MenuItem>
                                          ),
                                          permission?.delete === 1 && (
                                            <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                              Delete
                                            </MenuItem>
                                          ),
                                        ]}
                                       
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                

                        <div className="tab-pane " id="list-dataCancelled">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataCancelled} 
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                          initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                        renderRowActionMenuItems={({ row }) => [
                                          permission?.update === 1 && (
                                            <MenuItem key="edit" onClick={() => editItem(row.original)}>
                                              Edit
                                            </MenuItem>
                                          ),
                                          permission?.delete === 1 && (
                                            <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                              Delete
                                            </MenuItem>
                                          ),
                                        ]}
                                       
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                

                    
                        <div className="tab-pane " id="list-dataShipped">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataShipped} 
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                          initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                        renderRowActionMenuItems={({ row }) => [
                                          permission?.update === 1 && (
                                            <MenuItem key="edit" onClick={() => editItem(row.original)}>
                                              Edit
                                            </MenuItem>
                                          ),
                                          permission?.delete === 1 && (
                                            <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                              Delete
                                            </MenuItem>
                                          ),
                                        ]}
                                       
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                

                      
                        <div className="tab-pane " id="list-dataDelivered">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataDelivered} 
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          enableSorting={true} // Enable sorting
                                          initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                        renderRowActionMenuItems={({ row }) => [
                                          permission?.update === 1 && (
                                            <MenuItem key="edit" onClick={() => editItem(row.original)}>
                                              Edit
                                            </MenuItem>
                                          ),
                                          permission?.delete === 1 && (
                                            <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                              Delete
                                            </MenuItem>
                                          ),
                                        ]}
                                       
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                
   
                        </div>                             
                    </div>
                    </div>
                </div>
                </div>
            </section>
           
             
            </div>


            </div>
          )}

            </div>
            

           

              
          </div>
        </div>
      </div>
    </>
  );
};

export default Viewcontract;